import { ToggleGroup, ToggleGroupItem } from "@trillion/ui/components/ui/toggle-group";
import { RUN_DAYS, type RunDays } from "@/lib/run-days";

/** The page-wide days window above the run-history tabs (sc-114200). Controlled: the URL owns the value. */
export function RunDaysSelector({
  value,
  onChange,
}: {
  value: RunDays;
  onChange: (days: RunDays) => void;
}) {
  return (
    <ToggleGroup
      type="single"
      variant="outline"
      size="sm"
      aria-label="History window"
      value={String(value)}
      onValueChange={(next) => {
        // Clicking the pressed item emits "": keep the current window.
        if (next) onChange(Number(next) as RunDays);
      }}
    >
      {RUN_DAYS.map((days) => (
        <ToggleGroupItem key={days} value={String(days)}>
          {`${days}d`}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
